import './Preloader.scss'

const Preloader = (props: any) => {
    return <div className="loader"></div>
}

export default Preloader